export default __webpack_public_path__ + "static/media/eduYellow.6b8f8b23.svg";